import type { Invoice } from '../hooks/useInvoices'

// Gary's invoice rules (2026-10-01), aligned with Sage: an issued invoice is corrected with a
// Credit Note, not voided. These helpers only decide which buttons to SHOW -- the real checks
// live in the SECURITY DEFINER RPCs (20261001b_invoice_controls.sql) and, once
// 20261001c is run, in DB triggers.

export const VOID_REASONS = ['Wrong customer billed', 'Wrong amount', 'Duplicate invoice', 'Service cancelled', 'Other']
export const CREDIT_REASONS = ['Overcharged', 'Service cancelled', 'Customer complaint', 'Wrong customer billed', 'Rate correction', 'Other']

const isFinance = (roles: string[]) => roles.includes('ADMIN') || roles.includes('ACCOUNTS')

export function isCreditNote(inv: Invoice) { return inv.invoice_type === 'CREDIT_NOTE' }

// DRAFT: ADMIN/ACCOUNTS. ISSUED and never synced to Sage: ADMIN only. Everything else: no Void.
export function canVoid(inv: Invoice, roles: string[]): boolean {
  if (isCreditNote(inv) || inv.sage_invoice_id) return false
  if (inv.status === 'DRAFT') return isFinance(roles)
  if (inv.status === 'ISSUED') return roles.includes('ADMIN')
  return false
}

export function syncedToSageBlocksVoid(inv: Invoice, roles: string[]): boolean {
  return !isCreditNote(inv) && inv.status === 'ISSUED' && !!inv.sage_invoice_id && isFinance(roles)
}

export function canCredit(inv: Invoice, roles: string[]): boolean {
  return !isCreditNote(inv) && inv.status === 'ISSUED' && isFinance(roles)
}

export function canEdit(inv: Invoice, roles: string[]): boolean {
  return !isCreditNote(inv) && (inv.status === 'DRAFT' || inv.status === 'ISSUED') && isFinance(roles)
}

// Money edits (Sales amounts, VAT rate, Bill To, add/remove lines) are refused once synced to Sage.
export function canEditAmounts(inv: Invoice): boolean {
  return !inv.sage_invoice_id
}
